import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import _ from 'lodash';
import React, { Component } from 'react';
import SectionList from "react-native-web/dist/exports/SectionList";
import Text from "react-native-web/dist/exports/Text";
import PropTypes from 'prop-types';
import XDate from 'xdate';
import styleConstructor from "./style";
import asCalendarConsumer from "./asCalendarConsumer";
import { jsx as ___EmotionJSX } from "@emotion/core";

var commons = require("./commons");

var UPDATE_SOURCES = commons.UPDATE_SOURCES;

var AgendaList = function (_Component) {
  _inherits(AgendaList, _Component);

  var _super = _createSuper(AgendaList);

  function AgendaList(props) {
    var _this;

    _classCallCheck(this, AgendaList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onViewableItemsChanged", function (_ref) {
      var viewableItems = _ref.viewableItems;

      if (viewableItems && !_this.sectionScroll) {
        var topSection = _.get(viewableItems[0], 'section.title');

        if (topSection && topSection !== _this._topSection) {
          _this._topSection = topSection;

          if (_this.didScroll) {
            _.invoke(_this.props.context, 'setDate', _this._topSection, UPDATE_SOURCES.LIST_DRAG);
          }
        }
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onScroll", function (event) {
      if (!_this.didScroll) {
        _this.didScroll = true;
      }

      _.invoke(_this.props, 'onScroll', event);
    });

    _defineProperty(_assertThisInitialized(_this), "onMomentumScrollBegin", function (event) {
      _.invoke(_this.props.context, 'setDisabled', true);

      _.invoke(_this.props, 'onMomentumScrollBegin', event);
    });

    _defineProperty(_assertThisInitialized(_this), "onMomentumScrollEnd", function (event) {
      _this.sectionScroll = false;

      _.invoke(_this.props.context, 'setDisabled', false);

      _.invoke(_this.props, 'onMomentumScrollEnd', event);
    });

    _defineProperty(_assertThisInitialized(_this), "onHeaderLayout", function (_ref2) {
      var nativeEvent = _ref2.nativeEvent;
      _this.sectionHeight = nativeEvent.layout.height;
    });

    _defineProperty(_assertThisInitialized(_this), "renderSectionHeader", function (_ref3) {
      var title = _ref3.section.title;
      var today = XDate().toString(_this.props.dayFormat);
      var date = XDate(title).toString(_this.props.dayFormat);
      var todayString = XDate.locales[XDate.defaultLocale].today || commons.todayString;
      var sectionTitle = date === today ? todayString + ", " + date : date;
      return ___EmotionJSX(Text, {
        allowFontScaling: false,
        style: [_this.style.sectionText, _this.props.sectionStyle],
        onLayout: _this.onHeaderLayout
      }, sectionTitle);
    });

    _defineProperty(_assertThisInitialized(_this), "keyExtractor", function (item, index) {
      return _.isFunction(_this.props.keyExtractor) ? _this.props.keyExtractor(item, index) : String(index);
    });

    _this.style = styleConstructor(props.theme);
    _this._topSection = _.get(props, 'sections[0].title');
    _this.didScroll = false;
    _this.sectionScroll = false;
    _this.viewabilityConfig = {
      itemVisiblePercentThreshold: 20
    };
    _this.list = React.createRef();
    return _this;
  }

  _createClass(AgendaList, [{
    key: "getSectionIndex",
    value: function getSectionIndex(date) {
      var i;

      _.map(this.props.sections, function (section, index) {
        if (section.title === date) {
          i = index;
          return;
        }
      });

      return i;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var date = this.props.context.date;

      if (date !== this._topSection) {
        setTimeout(function () {
          var sectionIndex = _this2.getSectionIndex(date);

          _this2.scrollToSection(sectionIndex);
        }, 500);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props$context = this.props.context,
          updateSource = _this$props$context.updateSource,
          date = _this$props$context.date;

      if (date !== prevProps.context.date) {
        if (updateSource !== UPDATE_SOURCES.LIST_DRAG && updateSource !== UPDATE_SOURCES.CALENDAR_INIT) {
          var sectionIndex = this.getSectionIndex(date);
          this.scrollToSection(sectionIndex);
        }
      }
    }
  }, {
    key: "scrollToSection",
    value: function scrollToSection(sectionIndex) {
      if (this.list.current && sectionIndex !== undefined) {
        this.sectionScroll = true;
        this._topSection = this.props.sections[sectionIndex].title;
        this.list.current.scrollToLocation({
          animated: true,
          sectionIndex: sectionIndex,
          itemIndex: 0,
          viewPosition: 0,
          viewOffset: commons.isAndroid ? this.sectionHeight : 0
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return ___EmotionJSX(SectionList, _extends({}, this.props, {
        ref: this.list,
        keyExtractor: this.keyExtractor,
        showsVerticalScrollIndicator: false,
        onViewableItemsChanged: this.onViewableItemsChanged,
        viewabilityConfig: this.viewabilityConfig,
        renderSectionHeader: this.renderSectionHeader,
        onScroll: this.onScroll,
        onMomentumScrollBegin: this.onMomentumScrollBegin,
        onMomentumScrollEnd: this.onMomentumScrollEnd,
        onScrollToIndexFailed: function onScrollToIndexFailed(info) {
          console.warn('onScrollToIndexFailed info: ', info);
        }
      }));
    }
  }]);

  return AgendaList;
}(Component);

_defineProperty(AgendaList, "displayName", 'AgendaList');

_defineProperty(AgendaList, "propTypes", _objectSpread({}, SectionList.propTypes, {
  dayFormat: PropTypes.string,
  sectionStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array])
}));

_defineProperty(AgendaList, "defaultProps", {
  dayFormat: 'dddd, MMM d',
  stickySectionHeadersEnabled: true
});

var __DOCZ_DUMMY_EXPORT_DEFAULT = asCalendarConsumer(AgendaList);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/react-native-calendars/src/expandableCalendar/agendaList.js"
    }
  });
}